import { Helpers } from '../helpers';
class Cart {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `/wcs/resources/store/${storeId}/cart`;
        this.cartServicePath = `/wcs/resources/store/${storeId}/HPCartService`;
    }

    /**
     *
     * @param {*} params
     * @param {*} config
     * @param {*} onCalculate - Callback function to be called after cart is calculated.
     * @param {*} waitForAll - If true, wait for onCalculate to finish before returning. If false, return immediately.
     * @returns
     */
    get(params, config, onCalculate, waitForAll) {
        const { orderId, calculate, timestamp = true, ...restParams } = params || {};
        if (calculate && orderId) {
            return this.calculate(orderId, restParams, config, onCalculate);
        }

        const onCalcPromise = onCalculate ? onCalculate(orderId, restParams, config) : Promise.resolve();
        const waitPromises = waitForAll ? onCalcPromise : Promise.resolve();

        return this.http(`${this.path}/@self`, {
            params: { ...restParams, ...(timestamp ? { _: Date.now() } : {}) },
            method: 'get',
            ...config,
        }).then(resp => {
            const { data, status } = resp;
            return waitPromises.then(() => {
                //attempt to parse response
                if (status === 200 && data && data !== '') {
                    return data;
                } else {
                    return Promise.reject({});
                }
            }).catch(e => {
                //if wait promise fails, return cart data anyway
                if (status === 200 && data && data !== '') {
                    return data;
                } else {
                    return Promise.reject({});
                }
            });
        });
    }

    async calculate(orderId, params, config, onCalculate) {
        const data = {
            calculationUsageId: ['-1'],
            continue: ['1'],
            createIfEmpty: ['1'],
            deleteCartCookie: ['true'],
            deleteIfEmpty: ['*'],
            fromOrderId: ['*'],
            page: [''],
            toOrderId: ['.'],
            updatePrices: ['1'],
            URL: ['AjaxOrderItemDisplayView'],
            HPRestFlow: ['Y'],
        };

        return this.http
            .post(
                `${this.path}/${orderId}/calculate?URL=AjaxOrderItemDisplayView`,
                Helpers.parseFormData({ ...data, ...config }),
            )
            .then(resp => {
                const { data, status } = resp;
                //attempt to parse response
                if (status === 200 && data && data !== '') {
                    return this.get(params, config, onCalculate);
                } else {
                    console.log(`Error calculating cart: ${status}`);
                    return this.get(params, config, onCalculate);
                    // return Promise.reject({});
                }
            })
            .catch(e => {
                //TODO: Need to check if it's okay to proceed with cart call if calculate call fails
                console.log(`Error calculating cart: ${e}`);
                return this.get(params, config, onCalculate);
            });
    }

    shipmenCalculation(orderId) {
        return this.http(`AjaxOrderShipMethods`, { method: 'get', params: { orderId } });
    }

    deliveryOptions(params, config) {
        return this.http(`${this.cartServicePath}/delivery-options`, {
            params: { responseFormat: 'json', ...(params || {}) },
            method: 'get',
            ...config,
        }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return { ...data, updatedFromService: true };
            } else {
                return Promise.reject({});
            }
        });
    }

    carepackInfo(params, config) {
        return this.http(`${this.cartServicePath}/fetchHWWithoutCP`, {
            params: { responseFormat: 'json', _: Date.now(), ...(params || {}) },
            method: 'get',
            ...config,
        }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return data;
            } else {
                return Promise.reject({});
            }
        });
    }

    viewConfig(params, config) {
        return this.http(`${this.cartServicePath}/vieweditconfig`, {
            params: { responseFormat: 'json', ...(params || {}) },
            method: 'get',
            ...config,
        }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return data;
            } else {
                return Promise.reject({});
            }
        });
    }

    verifyCTO(params, config) {
        return this.http(`${this.cartServicePath}/verify-cart-cto-config`, {
            params: { responseFormat: 'json', ...(params || {}) },
            method: 'get',
            ...config,
        }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return data;
            } else {
                return Promise.reject({});
            }
        });
    }

    getAdditionalCartDetails(params, config) {
        return this.http(`${this.cartServicePath}/getAdditionalCartData`, {
            params: { responseFormat: 'json', ...(params || {}) },
            method: 'get',
            ...config,
        }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return data;
            } else {
                return Promise.reject({});
            }
        });
    }

    paypalExpressCheckout(params, config) {
        const { paypalUrl, ...restParams } = params || {};
        return this.http(paypalUrl, {
            params: {
                shippingAddressMadatory: 'false',
                plAction: 'xo',
                ...(restParams || {}),
            },
            method: 'post',
            ...config,
        }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                var response = JSON.parse(data.replace('/*', '').replace('*/', '').trim());
                return response;
            } else {
                return Promise.reject({});
            }
        });
    }
}

export default Cart;
